module.exports = __webpack_public_path__ + "img/image.95d943cf.png";